var map = {
	"./coins-fullGrey.svg": "3ee1",
	"./dashboard2-fullGrey.svg": "99c2",
	"./globe-nav-chevron-right-fullGrey.svg": "4d40",
	"./graph-bar-fullGrey.svg": "b132",
	"./info-fullGrey.svg": "3732",
	"./investment-history-fullGrey.svg": "d457",
	"./market-place-fullGrey.svg": "360c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "73a7";